import React, { useEffect, useState } from "react";
import { User } from "~/common/Store/models/User";
import {
  SelectedProduct,
  PromotedProductBrandAd,
} from "~/common/Store/models/ProductListing";
import ProductAd from "./ProductAd";

interface Props {
  productListingView: "list" | "grid";
  brandAd: PromotedProductBrandAd;
  user: User;
  mounted: boolean;
  fillPartialRowForGridView?: boolean;
  isTabletView?: boolean;
  itemsLength?: number;
  gridRef?: React.RefObject<HTMLDivElement>;
}

const PromotedProductAd = ({
  user,
  brandAd,
  productListingView,
  mounted,
  fillPartialRowForGridView = false,
  isTabletView = false,
  itemsLength = 0,
  gridRef,
}: Props) => {
  const { product } = brandAd;

  const [currentColCount, setCurrentColCount] = useState(0);

  useEffect(() => {
    const grid = gridRef?.current;
    if (!grid) return;

    const updateColumnCount = () => {
      const columns = getComputedStyle(grid)
        .getPropertyValue("grid-template-columns")
        .split(" ").length;
      setCurrentColCount(columns);
    };

    updateColumnCount(); // inital load

    const observer = new ResizeObserver(updateColumnCount);
    observer.observe(grid);

    return () => observer.disconnect();
  }, [gridRef]);

  // Promoted Product Ads only display sale price, p1, and lowest qty discount
  const selectedProduct: SelectedProduct = {
    ...product,
    activeSale: product.price.displaySalePrice,
    isOutlet: product.outletAttributes && product.outletAttributes.isOutlet,
    price: {
      ...product.price,
      minimumAdvertisedPriceProperties: {
        // Override MAP
        price: 0,
        type: "",
      },
    },
  };

  if (!product.isInStock) {
    return <></>;
  }

  const cellsToSpan = currentColCount - itemsLength;
  const spanLength = cellsToSpan > 1 ? cellsToSpan : 1;
  return (
    <>
      {fillPartialRowForGridView && productListingView === "grid" && (
        <div
          style={{
            gridColumn: `span ${spanLength}`,
            background: "#fff",
            borderRight: "1px solid #dbdfd8",
          }}
          data-testid="ad-partial-fill"
        />
      )}
      <ProductAd
        brandAd={brandAd}
        user={user}
        mounted={mounted}
        selectedProduct={selectedProduct}
        isTabletView={isTabletView}
      />
    </>
  );
};

export default PromotedProductAd;
